import { render, staticRenderFns } from "./BlockEl.vue?vue&type=template&id=706d9f0d&scoped=true&"
import script from "./BlockEl.vue?vue&type=script&lang=ts&"
export * from "./BlockEl.vue?vue&type=script&lang=ts&"
import style0 from "./BlockEl.vue?vue&type=style&index=0&id=706d9f0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706d9f0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VSheet})
